import { _report } from './log';
// 前端生成aid
export function createAid() {
  let aid =  (Math.floor(Math.random() * 10) || 1) + _uuid(3, 10) + new Date().getTime().toString().slice(2, 13);
  try {
    // 针对当aid的位数不足15位进行补位到15位
    if (aid.length < 15) {
      let beforeAid = aid;
      aid = aid + _uuid((15 - aid.length), 10);
      _report({
        module: 'c-imsdk-utils',
        method: '[createVisitor][createAid]',
        message: `beforeAid:${beforeAid} aid:${aid} time: ${new Date().getTime()}`,
      })
    } 
  }catch(e) {};
  
 return aid;
}
//前端生成uuid
export function guid() {
  return 'xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}
// 老webIM生成的方式
function _uuid(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [] as any[], i;
  radix = radix || chars.length;
  if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
      // rfc4122, version 4 form
      var r;
      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
              r = 0 | Math.random() * 16;
              uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
          }
      }
  }
  return uuid.join('');
}